import {
    UrlRewritesQuery as SourceUrlRewritesQuery
} from 'SourceQuery/UrlRewrites.query';
import { Field } from 'Util/Query';

/** @namespace Elganso/Query/UrlRewrites/Query */
export class UrlRewritesQuery extends SourceUrlRewritesQuery {
    _getUrlResolverFields() {
        return [
            'id',
            'sku',
            'type',
            this._getUrlRewritesAddtionalDataField()
        ];
    }

    _getUrlRewritesAddtionalDataField() {
        return new Field('additional_data')
            .addFieldList(this._getUrlRewritesAddtionalDataFields());
    }

    _getUrlRewritesAddtionalDataFields() {
        return [
            'use_product_list',
            'is_asesoramineto_online',
            'is_asesoramineto_active',
            'category_disabled',
            'hrefLang'
        ];
    }
}

export default new UrlRewritesQuery();
